"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPropertyAgentAdminDto = instanceOfPropertyAgentAdminDto;
exports.PropertyAgentAdminDtoFromJSON = PropertyAgentAdminDtoFromJSON;
exports.PropertyAgentAdminDtoFromJSONTyped = PropertyAgentAdminDtoFromJSONTyped;
exports.PropertyAgentAdminDtoToJSON = PropertyAgentAdminDtoToJSON;
exports.PropertyAgentAdminDtoToJSONTyped = PropertyAgentAdminDtoToJSONTyped;
/**
 * Check if a given object implements the PropertyAgentAdminDto interface.
 */
function instanceOfPropertyAgentAdminDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('fullName' in value) || value['fullName'] === undefined)
        return false;
    return true;
}
function PropertyAgentAdminDtoFromJSON(json) {
    return PropertyAgentAdminDtoFromJSONTyped(json, false);
}
function PropertyAgentAdminDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'fullName': json['fullName'],
    };
}
function PropertyAgentAdminDtoToJSON(json) {
    return PropertyAgentAdminDtoToJSONTyped(json, false);
}
function PropertyAgentAdminDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'fullName': value['fullName'],
    };
}
